import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Text } from '@leroy-merlin-br/backyard-react-ui'

const descriptionOccupationsStyles = ({ theme }) => css`
  color: ${theme.colors.n600};
  padding-left: ${theme.spacings.giga};
`

export const DescriptionOccupations = styled(Text)(descriptionOccupationsStyles)
